.toolbar {
  display: flex;
  padding: 0.5rem 0;
}
@media all and (orientation: portrait) {
  .toolbar {
    width: 100%;
  }
}

.actions {
  display: flex;
  margin-left: auto;
  text-align: right;
}

.loadingIcon {
  position: absolute;
  text-align: center;
  margin-top: 5rem;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiL2hvbWUvZGV2L3NyYy9jYXB0dXJlbGlmZS9yZXBvcy9DYXB0dXJlbGlmZS1hd3MvcHdhL3NyYy9hcHBzL3BvcnRhbC9jb21wb25lbnRzL1Rvb2xiYXIiLCJzb3VyY2VzIjpbImNsYXNzZXMubW9kdWxlLnNjc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7RUFDRTtFQUFlOztBQUVmO0VBSEY7SUFJSTs7OztBQUlKO0VBQ0U7RUFDQTtFQUNBOzs7QUFHRjtFQUNFO0VBQ0E7RUFDQSIsInNvdXJjZXNDb250ZW50IjpbIi50b29sYmFyIHtcbiAgZGlzcGxheTogZmxleDsgcGFkZGluZzogMC41cmVtIDA7XG5cbiAgQG1lZGlhIGFsbCBhbmQgKG9yaWVudGF0aW9uOiBwb3J0cmFpdCkge1xuICAgIHdpZHRoOiAxMDAlO1xuICB9XG59XG5cbi5hY3Rpb25zIHtcbiAgZGlzcGxheTogZmxleDtcbiAgbWFyZ2luLWxlZnQ6IGF1dG87XG4gIHRleHQtYWxpZ246IHJpZ2h0O1xufVxuXG4ubG9hZGluZ0ljb24ge1xuICBwb3NpdGlvbjogYWJzb2x1dGU7XG4gIHRleHQtYWxpZ246IGNlbnRlcjtcbiAgbWFyZ2luLXRvcDogNXJlbTtcbn1cbiJdfQ== */